export { LoyaltyFAQ, LoyaltyFAQEntry } from './LoyaltyFAQ';
